<template>
  <div class="StoreTurnover">
    <navbar title="营业额管理"></navbar>

    <!--门店类型营业额统计-->
    <div class="flex1 workload flex-column h100">
      <!--顶部选项-->
      <div class="mt10">
        <el-card class="box-card">
          <div>
            <!--开始时间-->
            <div class="inblock time">
              开始/结束时间:
              <el-date-picker
                  v-model="StoreTypeTime"
                  @change="StoreTypeTimeChange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </div>
        </el-card>
      </div>
      <!--数据展示-->
      <div class="flex1 mt10">
        <el-row type="flex" :gutter="30" justify="center">
          <el-col :span="7" class="item-l" v-for="(item,index) in StoreTypeListData" :key="index">
            <h2>{{item.totalMoney}}</h2>
            <p>{{item.name}}</p>
          </el-col>
        </el-row>
      </div>
    </div>


    <br><br>

    <!--单个门店营业额查询-->
    <div class="flex1 workload flex-column h100">
      <!--顶部选项-->
      <div class="mt10">
        <el-card class="box-card">
          <div>

            <!--开始时间-->
            <div class="inblock time">
              开始/结束时间:
              <el-date-picker
                  v-model="StoreSingleTime"
                  @change="StoreSingleChange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>

            <!--门店选择-->
            <div class="inblock m-left time">
              <el-select v-model="StoreSingleData.shop_id" @change="StoreSingleChange" placeholder="--请选择门店--">
                <el-option
                    v-for="(item,index) in allShop"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>

          </div>
        </el-card>
        <el-card v-if="StoreSingleListData.length != 0" class="box-card1">
          <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[20, 30, 40, 50]"
                :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="StoreSingleListData.info.count"
                background
            ></el-pagination>
          </div>
        </el-card>
      </div>
      <!--数据展示-->
      <div class="flex1 mt10">
        <el-table
            :data="StoreSingleListData.list"
            border
            style="width: 100%"
            :height="tableHeight"
            :row-class-name="tableRowClassName">
          <el-table-column prop="name" label="门店名称" sortable></el-table-column>
          <el-table-column prop="totalMoney" label="营业额" sortable></el-table-column>
          <el-table-column prop="startTime" label="开始时间"></el-table-column>
          <el-table-column prop="endTime" label="结束时间"></el-table-column>
        </el-table>

      </div>
    </div>


  </div>
</template>

<script>
  import header from '@/components/header'
  export default {
    components: {
      navbar: header
    },
    data () {
      return {
        page: 1,
        limit: 20,
        tableHeight: window.innerHeight - 200,
        StoreTypeTime: [new Date(), new Date()],   // 门店类型营业额
        StoreSingleTime: [new Date(), new Date()], // 单个门店营业额
        allShop: {},
        StoreSingleListData: [],
        // 单个门店营业额的数据
        StoreSingleData: {
          page: 1,
          limit: 20,
          shop_id: '',
          startTime: '',
          endTime: ''
        },
        // 门店类型营业额统计
        StoreTypeListData: [],
        StoreTypeData: {
          token: JSON.parse(localStorage.getItem("userInfo")).token,
          startTime: '',
          endTime: ''
        }
      }
    },
    created() {
      this.StoreTypeTime[0] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D');
      this.StoreTypeTime[1] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D');

      this.StoreSingleTime[0] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D');
      this.StoreSingleTime[1] = this.$utils.formatTime(new Date().getTime(), 'Y-M-D');
      this.getAllShop();
    },
    methods: {
      // 分页大小变化
      handleSizeChange(val) {
        console.log("分页大小变化: ", val)
        this.StoreSingleData.limit = val;
        this.StoreSingleChange()
      },

      // 当前页变化
      handleCurrentChange(val) {
        console.log("当前页变化: ", val)
        this.StoreSingleData.page = val;
        this.StoreSingleChange()
      },


      /**
       * 请求单个门店营业额 发送请求
       * @constructor
       */
      async StoreSingleGetData() {
        this.StoreSingleListData = await (await this.$http.shopMoney(this.StoreSingleData)).data.data
        console.log("this.StoreSingleListData: ", this.StoreSingleListData)
      },
      // 单个门店营业额 的 门店选择 和 时间选择发生改变的时候
      StoreSingleChange() {
        this.StoreSingleData.startTime = this.StoreSingleTime[0];
        this.StoreSingleData.endTime	 = this.StoreSingleTime[1];
        console.log("this.StoreSingleData: ", this.StoreSingleData)
        this.StoreSingleGetData()
      },

      /**
       * 门店类型营业额统计 发送请求
       * @returns {Promise<void>}
       * @constructor
       */
      async StoreTypeGetData() {
        this.StoreTypeListData = await (await this.$http.shopTypeMoney(this.StoreTypeData)).data.data
        console.log("this.StoreTypeListData: ", this.StoreTypeListData)
      },

      // 门店类型营业额统计 时间选择发生改变的时候
      StoreTypeTimeChange() {
        console.log("时间选择发生变化")
        this.StoreTypeData.startTime = this.StoreTypeTime[0];
        this.StoreTypeData.endTime	 = this.StoreTypeTime[1];
        this.StoreTypeGetData()

      },
      // 获取所有门店数据
      async getAllShop() {
        this.allShop = (await this.$http.allShop()).data.data;
      },
      tableRowClassName({ rowIndex }) {
        if (rowIndex % 2 == 0) {
          return 'warning-row';
        }
        return '';
      },
    }
  }
</script>

<style scoped lang="less">
  .m-left {
    margin-left: 20px;
  }
  .item-l {
    background: #06b84f;
    color: #fff;
    margin-bottom: 15px;
    padding: 40px 0;
    margin-left: 10px;
    text-align: center;
  }
</style>